// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CategoryFilter-module-categoryFilter-3garP{overflow-x:hidden;max-width:800px;display:flex;flex-direction:column;gap:10px}.CategoryFilter-module-list-2BVSb{list-style:none;display:flex;gap:24px;flex-wrap:wrap}@media(max-width: 768px){.CategoryFilter-module-list-2BVSb{flex-wrap:nowrap;gap:10px}}", ""]);
// Exports
exports.locals = {
	"categoryFilter": "CategoryFilter-module-categoryFilter-3garP",
	"list": "CategoryFilter-module-list-2BVSb"
};
module.exports = exports;
